namespace JupitersChoice {
    export class ReturnToBaseGameCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('FreeGameModel') _freeGameModel: FreeGameModel;
        @inject('FreeSpinsPromoModel') _freeSpinsPromoModel: Sapphire.FreeSpinsPromoModel;
        @inject('GameConfig') _config: Sapphire.GameConfig;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;
        @inject('StateModel') _stateModel: Sapphire.StateModel;
        @inject('AudioModel') _audioModel: AudioModel;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const cycler = this._componentManager.get('Cycler');
            const paylineDisplay = this._componentManager.get('PaylineDisplay');
            const reels = this._componentManager.get('Reels');
            const grids = this._config.get('external', 'grids');
            const reelsetType = grids[response.grid].reels;

            reels.resetOpacity();
            cycler.kill();
            paylineDisplay.clear();
            this._eventManager.publish('onResetFreeGameReelCrumbles')

            this._freeGameModel.isReturningFrom = true;

            this._layerManager.setVisibility('FreeGameJupiter', false);
            this._stateModel.changeSubgame('BaseGame');
            this._stateModel.changeState('InFreeGame');
            this._componentManager.get('FreeGamePopup').setOrientation(this._orientationModel.getCurrentOrientation());
            this._componentManager.get('SkipPaylinesButton').setOrientation(this._orientationModel.getCurrentOrientation());
            this._componentManager.get('PaylineDisplay').setOrientation(this._orientationModel.getCurrentOrientation());
            this._componentManager.onOrientationChange(this._orientationModel.isLandscape, 'Reels');

            // make sure reels are using correct reelset
            for (let i = 0; i < 6; i++) {
                reels.updateStripAndStopAt([i], reelsetType[response.rawReelIndices[i]], response.stops[i]);
            }

            this._componentManager.showComponents(['SpinButton']);

            if (this._freeSpinsPromoModel.isInProgress) {
                this._componentManager.get('FreeSpinsPromoSpinCounter').show();
            }

            TweenMax.delayedCall(2, () => {
                this._eventManager.publish('onReturnToBaseGameComplete');

                this._audioModel.returnToBaseGame();
            });
        }
    }
}